import {
  Button,
  Heading,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import vxmClassicImage from '../../../../../assets/images/shared/vxmclassic.svg';
import { externalRoutes, routes } from '../../../../../routes/routesConfig';
import { buildRedirectPageQueryParams } from '../../../../RedirectPage/RedirectPage';

export type SwitchVXMClassicModalProps = {
  onClose: () => void;
  isOpen: boolean;
};

export const SwitchVXMClassicModal: React.FC<SwitchVXMClassicModalProps> = ({
  onClose,
  isOpen,
}) => {
  const { t, i18n } = useTranslation(['home']);
  const history = useHistory();

  const routeToVxDesktop = () => {
    history.push({
      pathname: routes.redirect.path,
      search: buildRedirectPageQueryParams(
        externalRoutes.main(i18n.language),
        routes.login.path
      ),
    });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader pr={4}>
          <Image src={vxmClassicImage} width={'20rem'} margin={'40px auto 0'} />
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack w="full" spacing={4} padding={4}>
            <Heading
              as="h2"
              size="xl"
              children={t('home:switch.modalHeading')}
            />
            <Text children={t('home:switch.modalDescription')} />
            <Text children={t('home:switch.modalDescriptionMenu')} />
          </VStack>
        </ModalBody>
        <ModalFooter px={8}>
          <VStack minH="5.5rem" w="full">
            <Button
              width={'full'}
              onClick={routeToVxDesktop}
              children={t('home:switch.modalButton')}
            />
            {/* TODO: Create Helpcenter Article
            <Button variant="ghost" width={'full'} children={'Mehr erfahren'} /> */}
          </VStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
